import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppService } from './app.service';
import { ScrollStrategyOptions } from '@angular/cdk/overlay';
import { AuthService } from './services/auth/auth.service';
import { Router } from '@angular/router';
import { isArrayWithData } from './utilities/array.helpers';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
    visible: boolean = true;
    public title: string = 'Remitter UI';
    public hideLabel: boolean = false;
    public isMasterMember: boolean = false;
    public isLoggedIn: boolean = false;
    public myAccountMenuItems: any[] | undefined;
    public subMenuItems: any[] | undefined;
    public menuItems: any[] | undefined;
    public selectedNode: any;

    public constructor(
        public authService: AuthService,
        public appService: AppService,
        public router: Router,
    ) {
        let defaultAccountMenuItems: any = [
            {
                label: 'User Profile',
                icon: 'pi pi-user',
                command: () => {
                    this.router.navigate(['/userprofile']);
                },
            },
            {
                label: 'Logout',
                icon: 'pi pi-sign-out',
                command: () => {
                    this.onLogout();
                },
            },
        ];
        this.myAccountMenuItems = defaultAccountMenuItems;
    }

    onClickMenu = (item: any) => {
        if (item.NavigationNodes.length > 0) {
            this.router.navigate(['/navigate']);
            this.subMenuItems = item.NavigationNodes;
        } else {
            this.router.navigate(['/' + item.RoutePath]);
            this.subMenuItems = undefined;
            this.hideLabel = true;
        }
    };

    getSideBarWidth() {
        return this.hideLabel ? '' : this.isMasterMember ? '16vw' : '12vw';
    }

    onClickSubMenu = (item: any) => {
        if (item.NavigationNodes.length > 0) {
            this.subMenuItems = item.NavigationNodes;
        } else {
            this.router.navigate(['/' + item.RoutePath]);
            this.subMenuItems = undefined;
            this.hideLabel = true;
        }
    };

    public edit = (navigationNode: any) => {
        this.appService.navigateTo(
            '/navigationnode/' + navigationNode.NavigationNodeId,
        );
    };

    public add = (navigationNode: any) => {
        this.appService.navigateTo(
            '/navigationnode/0/' + navigationNode.NavigationNodeId,
        );
    };

    getIcon(label: any) {
        let returnValue = 'globe';
        switch (label) {
            case 'Home':
                returnValue = 'home';
                break;
            case 'Administration':
                returnValue = 'cog';
                break;
            case 'Lab':
                returnValue = 'shop';
                break;
            case 'Reports':
                returnValue = 'chart-bar';
                break;
            case 'Operations':
                returnValue = 'sliders-v';
                break;
            case 'Profile':
                returnValue = 'user';
                break;
            case 'ETL':
                returnValue = 'file-import';
                break;
            case 'Tags':
                returnValue = 'tag';
                break;
        }

        return returnValue;
    }

    getNodePath(node: any): string {
        if (!node.RoutePath) return '/';
        return node.RoutePath.startsWith('/')
            ? node.RoutePath
            : '/' + node.RoutePath;
    }

    public getSelectedNodePath(node: any): string {

        const segments: string[] = [];

        let current = node;

        while (current) {

            const data = current.data || current;

            if (data?.DisplayText) {
                segments.unshift(
                    this.toSlug(data.DisplayText)
                );
            }

            current = current.parent;
        }

        return segments.join('/');
    }

    isCurrentRoute(node: any): boolean {
        const currentRoute = this.router.url;
        // return this.isMatchingNodeOrChild(node, currentRoute);
        const routePath = this.getNodePath(node);
        if (routePath === currentRoute) {
            return true;
        }

        return false;
    }

    private isMatchingNodeOrChild(node: any, currentRoute: string): boolean {
        if ('/' + node.RoutePath === currentRoute) {
            return true;
        }

        if (node.children) {
            return node.children.some((child: any) =>
                this.isMatchingNodeOrChild(child, currentRoute),
            );
        }

        return false;
    }

    private mapMenuItems(nodes: any): any {
        let newNodes = undefined;
        if (isArrayWithData(nodes)) {
            newNodes = nodes.map((node: any) => ({
                ...node,
                children: node.NavigationNodes
                    ? this.mapMenuItems(node.NavigationNodes)
                    : [],
            }));

            const profileNode = newNodes.find(
                (i: any) => i.DisplayText === 'Profile',
            );

            newNodes = [
                ...newNodes.filter((i: any) => i.DisplayText !== 'Profile'),
                profileNode,
            ];
        }
        return newNodes;
    }

    public toggleNode(node: any, event: any) {
        if (node.children?.length) {
            node.expanded = !node.expanded;
            const fullPath = this.getSelectedNodePath(node);
            this.router.navigate(['menu-dashboard'],{queryParams: {path: fullPath}});
            event?.stopPropagation();
            return;
        } else if (node.RoutePath) {
            this.router.navigate([node.RoutePath]);
        }
    }

    toSlug(text: string): string { return text .toLowerCase() .replace(/\s+/g, '-') .replace(/[^\w\-]+/g, ''); }

    public ngOnInit() {
        this.appService.hasLoggedOut.subscribe((r: any) => {
            this.menuItems = undefined;
            this.subMenuItems = undefined;
            this.authService.loggedOut.emit(true);
            this.isLoggedIn = false;
            this.router.navigate(['/login']);
        });

        this.authService.loggedIn.subscribe((currentUser: any) => {
            this.appService.isShowPageSpinner = true;
            const currentSession = this.appService.getCurrentSession();

            if (!!currentSession) {
                this.appService.isLogInRoute = false;
                this.isLoggedIn = true;
                this.isMasterMember =
                    currentSession.AuthenticatedUser.User.Roles.filter(
                        (i: string) => i.toUpperCase() == 'MASTER',
                    ).length == 1;
                if (!this.menuItems) {
                    this.appService
                        .getNavigationNodes()
                        .subscribe((nodes: any) => {
                            this.menuItems = this.mapMenuItems(nodes);
                            this.appService.isShowPageSpinner = false;
                        });
                }
            }
        });

        if (!!this.appService.getCurrentSession() && !this.menuItems) {
            this.appService.isShowPageSpinner = true;
            this.isLoggedIn = true;
            this.appService.CurrentSession =
                this.appService.getCurrentSession();

            this.isMasterMember =
                this.appService
                    .getCurrentSession()
                    .AuthenticatedUser.User.Roles.filter(
                        (i: string) => i.toUpperCase() == 'MASTER',
                    ).length == 1;
            if (!this.menuItems) {
                this.appService.getNavigationNodes().subscribe((nodes: any) => {
                    if (
                        !!nodes &&
                        (nodes.status === 401 || nodes.status === 0)
                    ) {
                        this.onLogout();
                    } else {
                        this.menuItems = this.mapMenuItems(nodes);
                    }
                    this.appService.isShowPageSpinner = false;
                });
            }
        }

        if (window.innerWidth < 700) {
            if (this.appService._isnavigationcollapsed == false) {
                this.appService.toggleNavigation();
            }
        }
    }

    public goToLanding() {
        this.appService.navigateTo('/landing');
    }

    public onLogout() {
        this.appService.logout();
        this.authService.logout();
        this.router.navigate(['/login']);
    }

    public toggleTheme = () => {
        try {
            //if (this._isfullscreen == false) {
            //    ////window.document.body.requestFullscreen();
            //    setTimeout(function () {
            //        window.scrollTo(0, 1);
            //    }, 0);
            //    this._isfullscreen = true;
            //} else {
            //    ////window.document.exitFullscreen();
            //    setTimeout(function () {
            //        window.scrollTo(1, 1);
            //    }, 0);
            //    this._isfullscreen = false;
            //}
        } catch (e) {
            //alert(e.message);
        }
    };

    public toggleSidePane = () => {};
}
